import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _MoveAltLight(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("path", { fill: "currentColor", d: "m12 3 .312-.39L12 2.36l-.312.25zm-.5 6a.5.5 0 0 0 1 0zm4.812-3.19-4-3.2-.624.78 4 3.2zm-4.624-3.2-4 3.2.624.78 4-3.2zM11.5 3v6h1V3zM21 12l.39.312.25-.312-.25-.312zm-6-.5a.5.5 0 0 0 0 1zm3.19 4.812 3.2-4-.78-.624-3.2 4zm3.2-4.624-3.2-4-.78.624 3.2 4zM21 11.5h-6v1h6zM12 21l.312.39-.312.25-.312-.25zm-.5-6a.5.5 0 0 1 1 0zm4.812 3.19-4 3.2-.624-.78 4-3.2zm-4.624 3.2-4-3.2.624-.78 4 3.2zM11.5 21v-6h1v6zM3 12l-.39.312L2.36 12l.25-.312zm6-.5a.5.5 0 0 1 0 1zm-3.19 4.812-3.2-4 .78-.624 3.2 4zm-3.2-4.624 3.2-4 .78.624-3.2 4zM3 11.5h6v1H3z" })));
}
const MoveAltLight = forwardRef(_MoveAltLight);
export { MoveAltLight };
